import React, { useEffect, useState, memo } from 'react';
// import { useTranslation } from 'react-i18next';
import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space, Tooltip } from 'antd';
import classNames from 'classnames';
import type { MenuProps } from 'antd';
import { useKeycloak } from '@react-keycloak/web';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { RoundedIcon } from '../index';
import {
  commonState,
  setAdmin,
  setLoaderShow,
  setMyProfileModal,
} from '../../../app/base/commonSlice';
import avatarLogo from '../../../assets/person-circle.svg';
import Icons from '../../../configs/icon.config';

// eslint-disable-next-line import/no-named-as-default
import UserProfile from '../../template/Profile-modal/UserProfile';
import './styles.scss';
import { useGetUserProfileQuery } from '../../../app/auth/apiSlice';
import authorityGuard from '../../../utils/authorityGuard';
import {
  Guidedtour,
  useUpdateApplicationSettingMutation,
} from '../Tour/store/GuidedTourSlice';
import Translate from '../Translate';

interface AvatarProps {
  avatarImage?: string;
  classname?: string;
  styles?: React.CSSProperties;
}

function Avatar({ avatarImage, classname, styles }: AvatarProps) {
  const { t } = useTranslation();
  const { data: userProfile, refetch } = useGetUserProfileQuery();
  // const { profile } = useSelector(authState);
  // const guidedTour = profile.settings.guided_tour;
  // console.log(guidedTour);
  const [updateApplicationSetting] = useUpdateApplicationSettingMutation();
  const updatedTourSettings: Guidedtour = {
    guided_tour: 'true',
  };
  const navigate = useNavigate();
  // const { i18n } = useTranslation();
  const location = useLocation();
  const currentURL = location.pathname;
  const dispatch = useDispatch();
  const { isAdmin } = useSelector(commonState);
  const { keycloak } = useKeycloak();
  // const isEnglish = useMemo(() => language === 'en', [language]);
  const [showTooltip, setShowTooltip] = useState(true);
  const avatarStyle = {
    ...styles,
  };
  const classes = classNames('avatar', classname, 'dropdown-avatar');

  const { myProfileModalOpen } = useSelector(commonState);

  const handleAdminView = () => {
    const admin = !isAdmin;
    if (admin) {
      navigate('/admin');
    } else {
      navigate('/');
    }
  };

  const handleTour = async () => {
    navigate('/');
    try {
      await updateApplicationSetting(updatedTourSettings).unwrap();
      refetch();
    } catch (err) {
      console.error('Error updating guided tour settings:', err);
    }
  };

  const openUserProfile = () => {
    // setIsUserProfileOpen(true);
    dispatch(setMyProfileModal(true));
  };

  const closeUserProfile = () => {
    // setIsUserProfileOpen(false);
    dispatch(setMyProfileModal(false));
  };

  // useEffect(() => {
  //   if (!isEnglish) {
  //     i18n.changeLanguage('en');
  //   } else {
  //     i18n.changeLanguage('bn');
  //   }
  // }, [i18n, isEnglish]);

  useEffect(() => {
    const isAdminUrl = currentURL.startsWith('/admin');
    if (isAdminUrl) {
      dispatch(setAdmin(true));
    } else {
      dispatch(setAdmin(false));
    }
  }, [currentURL, dispatch]);

  const handleLogout = async () => {
    dispatch(setLoaderShow(false));
    localStorage.removeItem('MyBrac-admin');
    await keycloak?.logout();
  };

  // @ts-ignore
  const items: MenuProps['items'] = [
    {
      label: (
        <Button
          className="avatar-li"
          type="text"
          onClick={() => openUserProfile()}
        >
          {Icons.profile}
          <Translate en="User profile" bn="ইউজার প্রোফাইল" />
        </Button>
      ),
      key: '0',
      permission: true,
    },
    {
      type: 'divider',
      permission: isEmpty(userProfile?.permissions)
        ? false
        : authorityGuard(['access_admin_panel']),
    },
    {
      label: (
        <Button
          className="avatar-li"
          type="text"
          onClick={() => handleAdminView()}
        >
          {Icons.profileGear}
          {isAdmin ? (
            <Translate en="View as user" bn="ইউজার হিসাবে দেখুন" />
          ) : (
            <Translate en="View as admin" bn="অ্যাডমিন হিসাবে দেখুন" />
          )}
        </Button>
      ),
      permission: isEmpty(userProfile?.permissions)
        ? false
        : authorityGuard(['access_admin_panel']),
      key: '1',
    },
    {
      type: 'divider',
      permission: true,
    },
    {
      label: (
        <Button className="avatar-li" type="text" onClick={() => handleTour()}>
          {Icons.tourIcon}
          <Translate en="Take a tour" bn="অ্যাপের বিস্তারিত জানুন" />
        </Button>
      ),
      permission: !isAdmin,
      key: '2',
    },
    {
      type: 'divider',
      permission: !isAdmin,
    },
    {
      label: (
        <Button type="text" className="avatar-li" onClick={handleLogout}>
          {Icons.boxArrow}
          <Translate en="Logout" bn="লগ আউট" />
        </Button>
      ),
      key: '4',
      permission: true,
    },
  ].filter((item) => item.permission);

  return (
    <>
      <div id="dropdownAvatar" className="cursor-pointer">
        <button
          onClick={() => {
            openUserProfile();
          }}
        >
          <RoundedIcon
            height={35}
            width={35}
            imageUrl={avatarImage}
            classname="hover:scale-105"
          />
        </button>
        <Dropdown
          overlayClassName="dropdown-menu"
          menu={{ items }}
          trigger={['click']}
          placement="bottom"
          onOpenChange={(open) => {
            setShowTooltip(!open);
          }}
        >
          <Tooltip
            trigger={['hover', 'click']}
            title={showTooltip ? `${t('userDropdown.tooltip')}` : ''}
          >
            <Space className={classes} style={avatarStyle}>
              <div className="profile">
                <div className="name w-[90px]">
                  {userProfile?.first_name} {userProfile?.last_name}
                </div>
                <div className="pin">{userProfile?.username}</div>
              </div>
              <DownOutlined style={{ color: '#D10D74' }} />
            </Space>
          </Tooltip>
        </Dropdown>
      </div>
      {myProfileModalOpen && (
        <UserProfile
          other={false}
          visible={myProfileModalOpen}
          onClose={closeUserProfile}
          pin={userProfile?.staff_pin}
        />
      )}
    </>
  );
}

Avatar.defaultProps = {
  avatarImage: avatarLogo,
};

export default memo(Avatar);
